<template>
    <div class="camera-box">
        <p class="camera-p">为了确保您学习的有效性，需要您使用人脸验证服务，验证通过后才可正常学习。</p>
        <video id="video" :width="videoWidth" :height="videoHeight" v-show="!imgSrc"></video>
        <canvas id="canvas" :width="videoWidth" :height="videoHeight" v-show="imgSrc"></canvas>
        <p class="camera-p">拍摄您本人人脸，请确保正对摄像头，光线充足</p>
        <p style="color: red; text-align: left;padding-bottom: 10px;">拍照后请进入学习至少1分钟，否则可能会被视为作弊处理</p>
        <!-- <p class="camera-p">{{!imgSrc?'提示：请将头像居中按"拍照"键确认':''}}</p> -->
        <el-button type="primary" @click="setImage" v-if="!imgSrc" class="camera-btn">拍照</el-button>
        <el-button type="primary" v-if="imgSrc" @click="setFileUpload" class="camera-btn" :loading='uploadLoading'>上传
        </el-button>
        <el-button type="primary" v-if="imgSrc" @click="repeatUpload" class="camera-btn">重拍</el-button>
    </div>
</template>

<script>

export default {
    name: 'Camera',
    props: {
        show: { type: Boolean },
        //【可选】配合原生input本地上传，用于替换时执行删除
        deleteData: { type: Object },
        uploadLoading: {
            type: Boolean
        }
    },
    data () {
        return {
            videoWidth: '401',
            videoHeight: '300',
            thisCancas: null,
            thisContext: null,
            thisVideo: null,
            imgSrc: ``,
        }
    },
    mounted () {
        if (this.show) this.getCompetence()
    },
    beforeDestroy () {
        this.stopNavigator();
    },
    methods: {
        /**
         * 重新上传
         */
        repeatUpload () {
            this.imgSrc = '';
            this.getCompetence();
        },

        /*
         *@function  调用
         */
        getCompetence () {
            var _this = this
            this.thisCancas = document.getElementById('canvas')
            this.thisContext = this.thisCancas.getContext('2d')
            this.thisVideo = document.getElementById('video')
            // 旧版本浏览器可能根本不支持mediaDevices，我们首先设置一个空对象
            if (navigator.mediaDevices === undefined) {
                navigator.mediaDevices = {}
            }
            // 一些浏览器实现了部分mediaDevices，我们不能只分配一个对象
            // 使用getUserMedia，因为它会覆盖现有的属性。
            // 这里，如果缺少getUserMedia属性，就添加它。
            if (navigator.mediaDevices.getUserMedia === undefined) {
                navigator.mediaDevices.getUserMedia = function (constraints) {
                    // 首先获取现存的getUserMedia(如果存在)
                    var getUserMedia = navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.getUserMedia
                    // 有些浏览器不支持，会返回错误信息
                    // 保持接口一致
                    if (!getUserMedia) {
                        return Promise.reject(new Error('getUserMedia is not implemented in this browser'))
                    }
                    // 否则，使用Promise将调用包装到旧的navigator.getUserMedia
                    return new Promise(function (resolve, reject) {
                        getUserMedia.call(navigator, constraints, resolve, reject)
                    })
                }
            }
            var constraints = {
                audio: false,
                video: { width: this.videoWidth, height: this.videoHeight, transform: 'scaleX(-1)' }
            }
            navigator.mediaDevices.getUserMedia(constraints).then(function (stream) {
                // 旧的浏览器可能没有srcObject
                if ('srcObject' in _this.thisVideo) {
                    _this.thisVideo.srcObject = stream
                } else {
                    // 避免在新的浏览器中使用它，因为它正在被弃用。
                    _this.thisVideo.src = window.URL.createObjectURL(stream)
                }
                _this.thisVideo.onloadedmetadata = function (e) {
                    _this.thisVideo.play()
                }
            }).catch(err => {
                if (err = 'DOMException: Permission denied') {
                    this.$message('您的摄像头已禁用');
                }

                console.log(err)
            })
        },
        /*
         *保存
         **/
        setImage () {
            var _this = this
            // 点击，canvas画图
            _this.thisContext.drawImage(_this.thisVideo, 0, 0, _this.videoWidth, _this.videoHeight)
            // 获取图片base64链接
            var image = this.thisCancas.toDataURL('image/png')
            _this.imgSrc = image
        },
        /*
        *   转换
        */
        dataURLtoFile (dataurl, filename) {
            var arr = dataurl.split(',')
            var mime = arr[0].match(/:(.*?);/)[1]
            var bstr = atob(arr[1])
            var n = bstr.length
            var u8arr = new Uint8Array(n)
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n)
            }
            return new File([u8arr], filename, { type: mime })
        },
        /*
         *@function
        */
        stopNavigator () {
            this.thisVideo.srcObject.getTracks()[0].stop()
        },
        //上传图片
        setFileUpload () {
            //   console.log(this.imgSrc)
            this.stopNavigator();
            this.$emit('fileUpload', this.imgSrc)
        },
    },
    watch: {
        show (val) {
            if (val) {
                this.imgSrc = ``
                this.getCompetence()
            } else {
                this.stopNavigator()
            }
        },
    }
}
</script>

<style lang="less">
.camera-box {
    margin: 0 auto;
    text-align: center;

    .camera-p {
        font-size: 14px;
        font-family: "PingFang SC";
        font-weight: 400;
        color: rgba(154, 154, 154, 1);
        text-align: left;
        padding: 10px 0;
    }

    .camera-btn {
        //   margin-top: 20px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/my/faceCollection/Camera.vue